import Vue from 'vue'
import Router from 'vue-router'

const index = () => import(/* webpackChunkName:'home'*/ '@/pages/index/index'); //首页
const wava = () => import(/* webpackChunkName:'wava'*/ '@/pages/wava/wava'); //测试
const login = () => import(/* webpackChunkName:'login'*/ '@/pages/login/login'); //登录页
const detail = () => import(/* webpackChunkName:'detail'*/ '@/pages/detail/detail'); //详情页

Vue.use(Router)

export default new Router({
  mode: 'history',
  base:'',
  routes: [
    {path: '/',name: 'index',component: index,meta:  {title: '',requireAuth: true,keepAlive:true}},
    {path: '/wava',name: 'wava',component: wava,meta: {title: ''}},
    {path: '/login',name: 'login',component: login,meta: {title: ''}},
    {path: '/detail',name: 'detail',component: detail,meta: {title: ''}},
  ],
})



// WEBPACK FOOTER //
// ./src/router/index.js